import React, { useContext } from 'react';
import { useStore } from 'zustand';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';

import {
  InventoryTabItemName,
  inventoryStore,
} from '../../../../../InventoryStore';
import { useRowState } from '../../../../../hooks/useRowState';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { isEnabledByMessage } from '../../../tabViewUtils';

const RoomPriceDiscountRowComponent: React.FC<{
  packId: number;
  roomId: number;
}> = ({ packId, roomId }) => {
  const { currencyFormatter } = useContext(CurrencyContext);
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const { dateKeys } = useRowState(InventoryTabItemName.Rooms);

  return (
    <TableRow key={`price-${roomId}-${packId}`}>
      <LabelCell label="Package price" />

      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${roomId}`];

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: RoomOpeningInventory) => {
              const isDisabled = !isEnabledByMessage(values?.message);

              const packDetail = values?.packsDetails?.find(
                (pd) => pd.packId === packId
              );

              return (
                <LabelValueCell
                  labelPosition="bottom"
                  value={packDetail?.discountedTotalPrice ?? 0}
                  date={dateKey}
                  name={[...fieldName, 'discountedTotalPrice']}
                  label={
                    packDetail?.discount !== undefined
                      ? `-${packDetail.discount}%`
                      : undefined
                  }
                  formatter={() =>
                    packDetail?.discountedTotalPrice !== undefined
                      ? currencyFormatter(
                          !isEditMode
                            ? Math.floor(packDetail.discountedTotalPrice)
                            : packDetail.discountedTotalPrice
                        )
                      : '-'
                  }
                  disabled={isDisabled}
                  grayed={
                    values?.inventoryStatus === 'CLOSED' ||
                    values?.inventoryStatus === 'UNPUBLISHED'
                  }
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const RoomPriceDiscountRow = React.memo(RoomPriceDiscountRowComponent);
